import React from "react";
import {
  Divider,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  CardHeader,
  Container,
  Grid,
  Typography,
  Tooltip,
  useTheme,
  IconButton,
  Box,
  Tabs,
  Tab,
} from "@mui/material";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";
import { Link } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { getStatusLabel } from "src/Utils/Combined";
import { IRequestCompanyInfo } from "src/Types/module/UpdateRequest/RequestCompanyInfo";
interface IProps {
  isLoading: boolean;
  companyInfo: IRequestCompanyInfo[];
}
const CompanyInformationIndex = ({ isLoading, companyInfo }: IProps) => {
  const theme = useTheme();
  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Company Name</TableCell>
              <TableCell>Representative name</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableLoader />
            ) : companyInfo.length ? (
              <>
                {companyInfo.map((sCompanyInfo) => {
                  return (
                    <TableRow hover key={sCompanyInfo.request_id}>
                      <TableCell>
                        <Typography
                          variant="body1"
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {sCompanyInfo.member_company_id}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          variant="body1"
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {sCompanyInfo.user_member_company_name}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          variant="body1"
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {sCompanyInfo.user_member_representative_name}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          variant="body1"
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {getStatusLabel(sCompanyInfo.status)}
                        </Typography>
                      </TableCell>

                      <TableCell>
                        <Link
                          to={`/update-request/company-information/${sCompanyInfo.request_id}?memberid=${sCompanyInfo.user_member_id}`}
                        >
                          <Tooltip title="view" arrow>
                            <IconButton
                              sx={{
                                "&:hover": {
                                  background: theme.colors.primary.lighter,
                                },
                                color: theme.palette.primary.main,
                              }}
                              color="inherit"
                              size="small"
                            >
                              <VisibilityIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Link>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </>
            ) : (
              <TableNotFound />
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default CompanyInformationIndex;
